import React from "react";
import Button from "@material-ui/core/Button";
import withStyles from "@material-ui/core/styles/withStyles";
import Typography from "@material-ui/core/Typography";
import PropTypes from "prop-types";
import makeStyles from "@material-ui/styles/makeStyles";
import clsx from "clsx";
import Grid from "@material-ui/core/Grid";

const useStyles = makeStyles((theme) => ({
    inlineBlock: {
        display: "inline-block",
    },
    testing: {
        marginLeft: theme.spacing(1.75),
        color: theme.palette.grey["400"]
    }
}));

const AdminLAbelButton = withStyles((theme) => ({
    root: {
        backgroundColor: theme.palette.secondary["A400"],
        "&:hover": {
            backgroundColor: theme.palette.secondary["A400"],
        },
        paddingTop: theme.spacing(1.25),
        pointerEvents: "none",
        fontSize: 18,
        fontFamily: "Josefin Sans",
        fontWeight: 700,
        color: theme.palette.secondary["900"],
        width: 88,
        height: 34

    },
}))(Button);

const AdminButton = ({testing, classname}) => {

    const classes = useStyles();

    return (
        <div>
            <Grid
                className={classname}
                container
                direction="row"
                justify="flex-start"
                alignItems="center"
            >
                <Grid item>
                    <AdminLAbelButton
                        variant="contained"
                        color="primary"
                    >
                        {"ADMIN"}
                    </AdminLAbelButton>
                </Grid>

                {testing && (
                    <Grid item>
                        <Typography
                            variant="subtitle2"
                            className={clsx(classes.inlineBlock, classes.testing)}
                        >
                            {"Testing"}
                        </Typography>
                    </Grid>
                )}
            </Grid>
        </div>
    );
};

AdminButton.defaultProps = {
    testing: true
};

AdminButton.propTypes = {
    testing: PropTypes.bool,
    classname: PropTypes.string
};

export default AdminButton;
